export default class {

    Tags = [];

    IsParentSortingUpdated = false;

    IsShowAll = true;

    IsChanged = false;

    mapFromDto = function (dataArray) {
        dataArray.forEach(dto => this.Tags.push(new ParentTagVm().mapFromDto(dto)));
        return this;
    }

    mapToDto = function () {
        let tags = JSON.parse(JSON.stringify(this.Tags));
        
        let result = [];

        tags.forEach(e => {
            result.push({ Id: e.Id, SubTags: e.SubTags.map(s => s.Id) });
        });

        return result;
    }

    showOrHideAll = function () {
        this.IsShowAll = !this.IsShowAll;
        this.Tags.forEach(tag => tag.IsShow = this.IsShowAll);
    }
}

class ParentTagVm {
    
    Id = 0;

    Name = "";

    Sorting = 0;

    SubTags = [];

    IsShow = true;

    mapFromDto = function(dto) {
        this.Id = dto.Id;
        this.Name = dto.Name;

        dto.SubTags.forEach(subDto => this.SubTags.push(new SubTagVm().mapFromDto(subDto)));

        return this;
    }

    changeVisible = function() {
        this.IsShow = !this.IsShow;
    }

}

class SubTagVm {

    Id = 0;

    Name = "";

    Color = "";

    Sorting = 0;

    mapFromDto = function(dto) {
        this.Id = dto.Id;
        this.Name = dto.Name;
        this.Color = dto.Color == null ? "#00af00" : dto.Color;

        return this;
    }

}